import React from 'react';
import { render } from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { Route, Switch } from 'react-router';
import RecuperaPassword from './Aree/RecuperaPassword';
import ResettaPassword from './Aree/ResettaPassword';
import QueryStringHandler from './QueryStringHandler';
import { getParams, isCustomized } from './Utils';

const applicationStyle = isCustomized(getParams(window.location.href));
document.body.style.background += applicationStyle ? applicationStyle.background : null;

const RootComponent = (props) => <QueryStringHandler {...props} applicationStyle={applicationStyle} />;
const RecuperaPasswordComponent = (props) => <RecuperaPassword {...props} applicationStyle={applicationStyle} />;
const ResettaPasswordComponent = (props) => <ResettaPassword {...props} applicationStyle={applicationStyle} />;

const App = () => (
  <div className={applicationStyle ? applicationStyle.style : 'default'}>
    <HashRouter>
      <Switch>
        <Route path="/" exact component={RootComponent} />
        <Route path="/RecuperaPassword" component={RecuperaPasswordComponent} />
        <Route path="/ResettaPassword" component={ResettaPasswordComponent} />
        <Route path="/ResettaPasswordAltroCodice" component={ResettaPasswordComponent} />
      </Switch>
    </HashRouter>
  </div>
);

render(
  <App />,
  document.getElementById('appContainer'),
);
